define([
	"dojo/_base/declare",
	"./StringRich",
	"./_LocalizedMixin"
], function(declare,StringRich,_LocalizedMixin) {

	return declare([StringRich,_LocalizedMixin], {
	});
});